import axios from 'axios'

export default (sessionToken: string) => {
    axios.defaults.headers.common['Session-Token'] = sessionToken
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/Utils/ChangeSessionToken.ts